import { lazy } from "react";

const Veiculos = lazy(() => import("../../../features/veiculos/VeiculosPage"));
const NovoVeiculo = lazy(() => import("../../../pages/veiculos/novoVeiculo"));
const EditVehicle = lazy(() => import("../../../pages/veiculos/editarVeiculo"));
const VincularCliente = lazy(() => import("../../../features/veiculos/pages/VincularClientePage"));
const VisualizarClienteVinculado = lazy(() => import("../../../features/veiculos/pages/ClienteVinculadosPage"));

export const vehicleRoutes = [
  { path: "/veiculos", component: Veiculos, private: true },
  { path: "/novoVeiculo", component: NovoVeiculo, private: true },
  { path: "/novoVeiculo/:clientId", component: NovoVeiculo, private: true },
  { path: "/novoVeiculo/:companyId", component: NovoVeiculo, private: true },
  { path: "/editarVeiculo/:vehicleId", component: EditVehicle, private: true },
  { path: "/cliente/:vehicleId", component: VincularCliente, private: true },
  { path: "/visualizarClienteVinculado/:vehicleId/:clientId", component: VisualizarClienteVinculado, private: true },
];
